export default {
  // 組織コード
  code (state) {
    return state.code
  },

  // 組織名
  name (state) {
    return state.name
  },

  // ファビコン
  favicon (state) {
    return state.theme.favicon
  },

  // ヘッダナビのリンク集
  navs (state) {
    return state.theme.navs
  },

  // フッタナビのリンク集
  links (state) {
    return state.theme.links
  },

  // ユーザ登録に免許証情報が必要か
  needLicense (state) {
    return state.traits.needLicense
  },

  // 予約の流れで、いつのタイミングでログインが必要か
  needAuth (state) {
    return state.traits.needAuth
  },

  // 情報配信サービスを利用するか
  optins (state) {
    return state.traits.optins
  },

  // 支払方法の一覧
  paymentMethods (state) {
    return state.traits.paymentMethods
  },

  // 決済 API 情報
  paymentApi (state) {
    return state.traits.paymentApi
  },

  // メールの送信ドメイン
  emailDomain (state) {
    return state.traits.emailDomain
  },

  // カレンダー表示タイプ
  calendarType (state) {
    return state.traits.calendarType
  },

  // ユーザーメニューの制限
  userMenuLimited (state) {
    return state.traits.userMenuLimited
  },

  // オープンフラグ
  openFlg (state) {
    return state.traits.OpenFlg
  },

  // 入会時の同意事項
  agreements (state) {
    return state.agreements
  },

  // 入会時の同意事項はあるか
  hasAgreements (state) {
    const agreements = state.agreements
    if (Object.keys(agreements).length > 0) {
    } else {
      return false
    }
    return true
  },

  // 車両カテゴリの一覧
  carCategories (state) {
    return state.masters.carCategories || []
  },

  // 車種の一覧
  carTypes (state) {
    return state.masters.carTypes || []
  },

  // トップページURL
  top (state) {
    const URL = state.theme.topURL
    return URL
  },

  // トップページURL
  topURL (state) {
    let URL = state.theme.topURL
    if (URL) {
    } else {
      URL = '/reserve/' + state.code
    }
    return URL
  },

  // トップページのルート
  topRoute (state) {
    return {
      name: 'top',
      params: { orgcode: state.code }
    }
  },

  // ログイン後に移動するルート
  loginTo (state, getters) {
    return state.loginTo ? state.loginTo : getters.topRoute
  }
}
